var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _vm.selectedCustomField === null
          ? _c("span", [_vm._v("Add Shipment Custom Field")])
          : _vm._e(),
        _vm.selectedCustomField !== null
          ? _c("span", [
              _vm._v("Edit " + _vm._s(_vm.selectedCustomField.label)),
            ])
          : _vm._e(),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          { staticClass: "form-wrapper", attrs: { validator: _vm.$v.form } },
          [
            _vm.selectedCustomField !== null
              ? _c(
                  "form-group",
                  { attrs: { label: "Id", name: "label" } },
                  [
                    _c("md-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "form-group",
              { attrs: { label: "Label", name: "label" } },
              [
                _c("md-input", {
                  model: {
                    value: _vm.form.label,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "label", $$v)
                    },
                    expression: "form.label",
                  },
                }),
              ],
              1
            ),
            _c(
              "form-group",
              { attrs: { name: "type" } },
              [
                _vm.customFieldTypes
                  ? _c("vue-select", {
                      attrs: {
                        options: _vm.customFieldTypes,
                        placeholder: "Type",
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.optionBasedFieldTypes.includes(_vm.form.type)
              ? _c("div", { staticClass: "md-layout md-size-100 options" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "form-group",
                        { attrs: { name: "options" } },
                        [
                          _c("md-input", {
                            attrs: { placeholder: "Option" },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.addOption($event)
                              },
                            },
                            model: {
                              value: _vm.optionValue,
                              callback: function ($$v) {
                                _vm.optionValue = $$v
                              },
                              expression: "optionValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "md-layout-item md-size-0 add-icon",
                      on: { click: _vm.addOption },
                    },
                    [_c("md-icon", [_vm._v("add")])],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.optionBasedFieldTypes.includes(_vm.form.type) &&
            _vm.form.options.length
              ? _c(
                  "div",
                  { staticClass: "options-table" },
                  [
                    _c("label", [_vm._v("Available Options:")]),
                    _c(
                      "md-table",
                      _vm._l(_vm.form.options, function (option, index) {
                        return _c(
                          "md-table-row",
                          { key: index },
                          [
                            _c(
                              "md-table-cell",
                              [
                                _c(
                                  "form-group",
                                  [
                                    _c("md-input", {
                                      model: {
                                        value: option.value,
                                        callback: function ($$v) {
                                          _vm.$set(option, "value", $$v)
                                        },
                                        expression: "option.value",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.form.showAsBadge
                              ? _c(
                                  "md-table-cell",
                                  { staticClass: "color-picker-cell" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "color-swatch-row" },
                                      [
                                        _vm._l(
                                          _vm.badgeColorPalette,
                                          function (palette) {
                                            return _c("span", {
                                              key: palette.key,
                                              staticClass: "color-swatch",
                                              class: {
                                                "is-selected":
                                                  option.color === palette.hex,
                                              },
                                              style: {
                                                backgroundColor: palette.hex,
                                              },
                                              attrs: { title: palette.key },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectPaletteColor(
                                                    index,
                                                    palette.hex
                                                  )
                                                },
                                              },
                                            })
                                          }
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-swatch custom-swatch",
                                            class: {
                                              "is-selected": _vm.isCustomColor(
                                                option.color
                                              ),
                                            },
                                            attrs: { title: "Custom" },
                                            on: {
                                              click: function ($event) {
                                                _vm.customHexEditingIndex =
                                                  _vm.customHexEditingIndex ===
                                                  index
                                                    ? null
                                                    : index
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("colorize")])],
                                          1
                                        ),
                                        _vm.customHexEditingIndex === index
                                          ? _c("md-input", {
                                              staticClass: "custom-hex-input",
                                              class: {
                                                "is-invalid":
                                                  option.color &&
                                                  !_vm.isValidHex(option.color),
                                              },
                                              attrs: { placeholder: "#RRGGBB" },
                                              model: {
                                                value: option.color,
                                                callback: function ($$v) {
                                                  _vm.$set(option, "color", $$v)
                                                },
                                                expression: "option.color",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "md-table-cell",
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-just-icon md-danger md-simple",
                                    attrs: { title: "delete option" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.removeOption(index)
                                      },
                                    },
                                  },
                                  [_c("md-icon", [_vm._v("close")])],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              [
                _c(
                  "md-checkbox",
                  {
                    model: {
                      value: _vm.form.isRequired,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isRequired", $$v)
                      },
                      expression: "form.isRequired",
                    },
                  },
                  [_vm._v("\n                    Required\n                ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "md-checkbox",
                  {
                    model: {
                      value: _vm.form.includeInPodPdf,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "includeInPodPdf", $$v)
                      },
                      expression: "form.includeInPodPdf",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    Include in Proof Of Delivery PDF\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.badgeEligibleFieldTypes.includes(_vm.form.type)
              ? _c(
                  "div",
                  [
                    _c(
                      "md-checkbox",
                      {
                        model: {
                          value: _vm.form.showAsBadge,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "showAsBadge", $$v)
                          },
                          expression: "form.showAsBadge",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Show as badge\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _vm.selectedCustomField === null
          ? _c(
              "md-button",
              {
                staticClass: "dialog-button md-primary",
                on: { click: _vm.addShipmentCustomField },
              },
              [_vm._v("\n            Add\n        ")]
            )
          : _vm._e(),
        _vm.selectedCustomField !== null
          ? _c(
              "md-button",
              {
                staticClass: "dialog-button md-primary",
                on: { click: _vm.editShipmentCustomField },
              },
              [_vm._v("\n            Save\n        ")]
            )
          : _vm._e(),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("\n            Cancel\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }